import Vue from 'vue';
import productTagTransformer from './../../transformers/productTag';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productTagTransformer.fetch(errors));
};

export default (id, productTag) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/product_tags/${id}`, productTag)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productTag/update.js